import { jsx as _jsx } from "react/jsx-runtime";
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { colors } from 'syf-component-library/defaultTheme';
import { FAL_EXCLAMATION_CIRCLE } from '../../const/iconProps';
export const ErrorIcon = () => {
    return (_jsx(FontAwesomeIcon, { color: colors.error, icon: FAL_EXCLAMATION_CIRCLE, size: "1x" }));
};
